module.exports = __webpack_public_path__ + "static/media/folder.ac94bb01.svg";